import { iots } from '@code-expert/prelude';
import { query } from '/imports/modules/Routing';

export const messagesSectionKeys = {
  inbox: null,
  archive: null,
  notifications: null,
};

export type MessagesSection = keyof typeof messagesSectionKeys;

export const MessagesSection = iots.keyof(messagesSectionKeys);

export const messagesSectionQuery = query(
  iots.exact(iots.partial({ section: iots.keyof(messagesSectionKeys) })),
);
